import { render } from "./AllMetricGroupList.vue?vue&type=template&id=e6cb0bcc"
import script from "./AllMetricGroupList.vue?vue&type=script&lang=js"
export * from "./AllMetricGroupList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__